import React from 'react';
import PropTypes from 'prop-types';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { makeStyles } from '@material-ui/core/styles';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { PATHNAMES } from '../../constants/paths';

import wlConfig from '../../constants/wlConfig';

const {
  theme: {
    styles: {
      ccpaBannerStyles: {
        rootStyles: {
          small: {
            backgroundColor: backgroundColorSmall,
            color: textColorSmall,
          },
          large: {
            backgroundColor: backgroundColorLarge,
            color: textColorLarge,
          },
        },
        iconCardButtonLink: {
          small: iconCardButtonLinkSmall,
          large: iconCardButtonLinkLarge,
        },
      },
    },
  },
} = wlConfig;

const propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

const defaultProps = {
  isOpen: false,
  onClose: () => {},
};

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'sticky',
    zIndex: 10,
    top: 0,
    marginTop: -2,
    padding: '19px 19px 4px 19px',
    backgroundColor: backgroundColorSmall,
    color: textColorSmall,
    [theme.breakpoints.up('xs')]: {
      padding: 16,
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 148,
      paddingRight: 148,
      backgroundColor: backgroundColorLarge,
      color: textColorLarge,
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  infromationUseLink: {
    fontWeight: 700,
    color: textColorSmall,
    cursor: 'pointer',
    [theme.breakpoints.up('lg')]: {
      color: textColorLarge,
    },
  },
  iconCardButtonLink: {
    [theme.breakpoints.up('xs')]: {
      ...iconCardButtonLinkSmall,
    },
    [theme.breakpoints.up('lg')]: {
      ...iconCardButtonLinkLarge,
    },
  },
}));

function CCPABanner({ isOpen, onClose, history }) {
  const classes = useStyles();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  if (!isOpen) return null;

  const ccpaActions = [
    <Button
      color="primary"
      size="small"
      className={classes.iconCardButtonLink}
      data-testid="ccpaBanner_dismissBtn"
      key="ccpaBanner_dismissBtn"
      onClick={onClose}
    >
      Dismiss
    </Button>,
    <Button
      color="primary"
      size="small"
      className={classes.iconCardButtonLink}
      data-testid="ccpaBanner_actionBtn"
      key="ccpaBanner_actionBtn"
      onClick={() => {
        history.push(PATHNAMES.PRIVACY_POLICY);
      }}
    >
      Learn More
    </Button>,
  ];

  return (
    <Box className={classes.container} data-testid="ccpaBanner">
      <Grid
        container
        wrap="nowrap"
        alignItems="center"
        alignContent="center"
        spacing={2}
        data-testid="ccpaBanner_container"
      >
        <Grid item xs="auto" sm={6} md="auto">
          <Typography>
            {!isMobile && `Farmers is committed to your privacy and security. `}
            Learn more about your{' '}
            <Link
              className={classes.infromationUseLink}
              onClick={() => {
                history.push(PATHNAMES.PRIVACY_POLICY);
              }}
            >
              Personal Information Use.
            </Link>
          </Typography>
        </Grid>
        {!isMobile && (
          <Grid item style={{ marginLeft: 'auto' }}>
            {ccpaActions}
          </Grid>
        )}
      </Grid>
      {isMobile && <Box className={classes.buttonContainer}>{ccpaActions}</Box>}
    </Box>
  );
}

CCPABanner.propTypes = propTypes;
CCPABanner.defaultProps = defaultProps;

export default CCPABanner;
